import { Button } from "@mui/material";

import {
  ShareIcon,
  ArrowDownTrayIcon,
  TrashIcon
} from "@heroicons/react/24/solid";
import { toast } from "react-hot-toast";

import { useState } from "react";
import { useMediaQuery } from "react-responsive";
import { ModalShareProfile } from "../../../../components/ModalShareProfile";
import { ModalSheetChoice } from "./ModalShet/ModalSheetChoice";
import { ModalSheetShareProfile } from "./ModalSheetShareProfile/ModalSheetShareProfile";

import RarLogo from "../../../../assets/rar.png";
import ZipLogo from "../../../../assets/zip.png";
import PdfLogo from "../../../../assets/pdf.png";
import Api from "../../../../helpers/Api";

import styles from "./styles.module.css";

export function Documents({
  documentsPaciente,
  PatientNameAndId,
  imagemPerfil,
}: any) {
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [downloadingIndex, setDownloadingIndex] = useState(-1);
  const [selectedImages, setSelectedImages] = useState<string[]>([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isModalSheetChoiceOpen, setModalSheetChoiceOpen] = useState(false);
  const showAddButton = selectedImages.length > 0;
  const [pdfUrl, setPdfUrl] = useState("");
  const isMobileScreen = useMediaQuery({ query: "(max-width: 684px)" });
  const [isModalSheetShareProfileOpen, setModalSheetShareProfileOpen] =
    useState(false);
  let touchTimer = null;

  const handleImageClick = (imageLink: string) => {
    setSelectedImages((prevSelected) =>
      prevSelected.includes(imageLink)
        ? prevSelected.filter((link) => link !== imageLink)
        : [...prevSelected, imageLink]
    );
    setPdfUrl(imageLink);
  };

  const openPDF = (pdfUrl: string) => {
    console.log(pdfUrl)
    const googleDocsUrl = `${pdfUrl}`;
    window.open(googleDocsUrl, "_blank");
  };

  const downloadPDF = () => {
    if (pdfUrl && !isMobileScreen) {
      window.open(pdfUrl);
    } else {
      selectedImages?.map((link) => {
        if (link) window.open(link);
      });
    }
  };

  const downloadDicomZip = async (link: string, imageIndex: number, patientNameAndId: { Paciente: string; Id: number }) => {
    try {
      const [, idCliente, seqAtend, complemento] = link.match(/RenderFilePatient\/(\d+)\/(\d+)\/(.+)$/);

      // Criando um link direto para download
      const downloadLink = document.createElement('a');
      downloadLink.href = link;
      downloadLink.setAttribute('download', seqAtend + complemento);
      downloadLink.setAttribute('target', '_blank');
      downloadLink.style.display = 'none';
      document.body.appendChild(downloadLink);
      
      // Forçando o clique no link
      downloadLink.click();

      // Removendo o link após iniciar o download
      document.body.removeChild(downloadLink);

    } catch (error) {
      console.error('Desculpe', error);
      toast.error('Desculpe, houve um erro ao tentar realizar o download. Por favor, tente novamente mais tarde.');
    }
  };

  const handleOPenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleOpenModalSheetChoice = () => {
    if (isMobileScreen && selectedImages.length >= 1) {
      setModalSheetChoiceOpen(true);
    }
  };

  const handleCloseModalSheetChoice = () => {
    setModalSheetChoiceOpen(false);
  };

  const handleOpenModalSheetShareProfile = () => {
    setModalSheetShareProfileOpen(true);
  };

  const handleCloseModalSheetShareProfile = () => {
    setModalSheetShareProfileOpen(false);
  };

  const handleImageTouchStart = () => {
    touchTimer = setTimeout(() => {
      handleOpenModalSheetChoice();
    }, 1000);
  };

  const handleImageTouchEnd = () => {
    clearTimeout(touchTimer);
  };

  const modifiedDocumentsPaciente = documentsPaciente?.map((image: any) => {
    // Não modificar o link do documento especial eVol-DX
    if (image.isEvolDx) {
      return image;
    }
    
    return {
      ...image,
      link: image.complemento.endsWith('.pdf') 
        ? image.link.replace("getfile.aspx", "PdfView")
        : image.link.replace("PdfView", "getfile.aspx"),
    };
  });

  return (
    <div className={styles.wrapper}>
      {documentsPaciente?.length === 0 ? (
        <div
          style={{
            textAlign: "center",
            paddingTop: "40px",
            color: "#afafaf",
            fontWeight: 500
          }}
        >
          <p>Sem documentos no momento.</p>
        </div>
      ) : (
        <>
          <div className={styles.containerButtons}>
            {showAddButton && (
              <div className={`${styles.containerButtons_select_show}`}>
                <div className={styles.containerButton_delete}>
                  <Button
                    className={`${styles.buttonDelete} 
                                            ${isMobileScreen
                        ? styles.buttonMobile
                        : ""
                      }`}
                  >
                    <TrashIcon width={20} height={20} />{" "}
                    {!isMobileScreen && "Excluir"}
                  </Button>
                </div>

                <div className={styles.containerButton_download}>
                  <Button
                    className={`${styles.buttonDownload} 
                                            ${isMobileScreen
                        ? styles.buttonMobile
                        : ""
                      }`}
                    onClick={() => downloadPDF()}
                  >
                    <ArrowDownTrayIcon width={20} height={20} />{" "}
                    {!isMobileScreen && "Baixar"}
                  </Button>
                </div>

                <div className={styles.containerButton_share}>
                  <Button
                    className={`${styles.buttonShare} 
                                            ${isMobileScreen
                        ? styles.buttonMobile
                        : ""
                      }`}
                    onClick={
                      !isMobileScreen
                        ? handleOPenModal
                        : handleOpenModalSheetShareProfile
                    }
                  >
                    <ShareIcon width={20} height={20} />{" "}
                    {!isMobileScreen && "Compartilhar"}
                  </Button>
                </div>
              </div>
            )}

            <div>
            </div>
          </div>

          <div className={styles.wrapperImg}>
            {
              <div className={styles.wrapper_imagens}>
                {modifiedDocumentsPaciente?.map((image: any, imageIndex: number) => (
                  <div
                    key={imageIndex}
                    className={`${styles.wrapperImage}`}
                    style={{
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      // Verificar se é o documento especial eVol-DX
                      if (image.isEvolDx) {
                        window.open('https://cdt.com.br/cli/p/artigos.aspx?q=Downloads', '_blank');
                        return;
                      }
                      
                      if (image.complemento.endsWith('.pdf')) {
                        // Para PDFs, usa o PdfView
                        let url = image.link;
                        if (!/^https?:\/\//i.test(url)) {
                          url = `https://serapi.cdt.com.br${url}`;
                        }
                        window.open(url, '_blank');
                      } else {
                        // Para outros arquivos, faz download direto
                        let url = image.linkDownload;
                        if (!/^https?:\/\//i.test(url)) {
                          url = `https://serapi.cdt.com.br${url}`;
                        }
                        window.open(url, '_blank');
                      }
                    }}
                  >
                    <div
                      className={`${styles.containerImage}`}
                      onTouchStart={handleImageTouchStart}
                      onTouchEnd={handleImageTouchEnd}
                    >
                      <div
                        className={
                          selectedImages.includes(image.link) && styles.containerImage_active
                        }
                      ></div>
                      <img
                        src={
                          image.complemento.endsWith('.rar') || image.complemento.endsWith('.zip')
                            ? `${image.complemento.endsWith('.zip') ? ZipLogo : RarLogo}`
                            : image.complemento.endsWith('.pdf') ? PdfLogo
                              : `${image.icone}?tw=430&th=429`
                        }
                        title={
                          image.complemento.endsWith('.rar') || image.complemento.endsWith('.zip')
                            ? 'Download'
                            : 'Visualizar PFD'
                        }
                        style={{ cursor: 'pointer' }}
                        onError={(e: any) => {
                          e.target.onerror = null;
                          e.target.src =
                            'https://cyberbullying.org/wp-content/uploads/2019/02/pdf-download-300x300.png';
                        }}
                      />
                    </div>

                    <div className={styles.containerContentImage}>
                      <strong>{image.nome}</strong>
                    </div>
                  </div>
                ))}
              </div>
            }
          </div>
        </>
      )}

      {isModalOpen && (
        <ModalShareProfile
          isOpen={isModalOpen}
          onRequestClose={handleCloseModal}
          selectedImages={selectedImages}
          PatientNameAndId={PatientNameAndId}
        />
      )}
      {isModalSheetChoiceOpen && (
        <ModalSheetChoice
          isOpen={isModalSheetChoiceOpen}
          onRequestClose={handleCloseModalSheetChoice}
          handleOpenModalSheetShareProfile={handleOpenModalSheetShareProfile}
          selectedImages={selectedImages}
        />
      )}
      {isModalSheetShareProfileOpen && (
        <ModalSheetShareProfile
          isOpen={isModalSheetShareProfileOpen}
          onRequestClose={handleCloseModalSheetShareProfile}
          selectedImages={selectedImages}
          PatientImageSource={imagemPerfil}
          PatientNameAndId={PatientNameAndId}
        />
      )}
    </div>
  );
}
